import type { LucideIcon } from "@lucide/svelte";
import type { SectionTheme } from "#lib/web-ui/primitives/index.js";

export type FaqItem = {
	question: string;
	answer: string;
};

export type FaqItemWithIcon = FaqItem & {
	icon: LucideIcon;
};

export type FaqBaseProps = {
	theme?: SectionTheme;
	id?: string;
	title?: string;
	subtitle?: string;
	items?: FaqItem[];
	contactHref: string;
};

export const faqDefaults = {
	theme: "muted" as SectionTheme,
	id: "faq",
	title: "Frequently Asked Questions",
	subtitle:
		"Secondary descriptive text that provides context for the items listed below, ensuring the layout remains balanced.",
	items: [
		{
			question: "Question Label One Goes Here?",
			answer: "Placeholder text for the first answer. This section contains mid-length descriptive text to simulate a standard response. It helps visualize how multiple lines of text will wrap within the container."
		},
		{
			question: "Question Label Two Goes Here?",
			answer: "Placeholder text for the second answer. Short and concise data point goes here. This ensures the layout stays consistent even when the content is slightly shorter than average."
		},
		{
			question: "Question Label Three Goes Here?",
			answer: "Placeholder text for the third answer. This is a longer block of dummy text designed to test the maximum height of your component. It includes extra sentences to see how the UI handles overflow."
		},
		{
			question: "Question Label Four Goes Here?",
			answer: "Placeholder text for the fourth answer. A medium-length response that mimics a typical explanation. Useful for checking vertical rhythm and spacing between different list items."
		}
	]
} satisfies Partial<FaqBaseProps>;
